import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SiteContentRow = {
  key: string;
  value: string;
  type: "text" | "richtext";
  group_name: string;
  label: string;
  sort_order: number;
};

export const useSiteContent = () => {
  const query = useQuery({
    queryKey: ["site_content"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_content")
        .select("*")
        .order("sort_order");
      if (error) throw error;
      return (data ?? []) as SiteContentRow[];
    },
    staleTime: 1000 * 60,
  });

  const map = new Map<string, string>();
  for (const row of query.data ?? []) map.set(row.key, row.value);

  const t = (key: string, fallback: string) => {
    const v = map.get(key);
    return v && v.length > 0 ? v : fallback;
  };

  return { t, rows: query.data ?? [], loading: query.isLoading, refetch: query.refetch };
};
